import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ClipLoader } from "react-spinners";

function Tours() {
  const [dayCount, setDayCount] = useState(0);
  const [inputs, setInputs] = useState([]);
  const [showInputs, setShowInputs] = useState(false);
  const [nextId, setNextId] = useState(null);
  const [tourDescription, setTourDescription] = useState('');
  const [tourRate, setTourRate] = useState('');
  const [tourTitle, setTourTitle] = useState('');

  // NEW: Route overview fields
  const [routeImage, setRouteImage] = useState(null);
  const [routeDescription, setRouteDescription] = useState('');
  // Key to force-reset the file input after submit
  const [routeImageKey, setRouteImageKey] = useState(0);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getnextId();
  }, []);

  // (Slightly cleaned) async/await version
  const getnextId = async () => {
    try {
      const res = await axios.get('https://genzserver.mylksystems.com/Tours/getnextId');
      if (res?.data?.nextId != null) {
        setNextId(res.data.nextId);
        console.log('Next Tour ID:', res.data.nextId);
      }
    } catch (error) {
      console.error('Error fetching next ID:', error);
    }
  };

  const handleDayChange = (e) => {
    const n = parseInt(e.target.value, 10);
    setDayCount(Number.isNaN(n) ? 0 : n);
  };

  const handleSubmitDays = () => {
    const newInputs = Array.from({ length: dayCount }, () => ({
      photo: null,
      description: '',
    }));
    setInputs(newInputs);
    setShowInputs(true);
  };

  const handlePhotoChange = (index, file) => {
    const updated = [...inputs];
    updated[index].photo = file;
    setInputs(updated);
  };

  const handleDescriptionChange = (index, desc) => {
    const updated = [...inputs];
    updated[index].description = desc;
    setInputs(updated);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append('tourID', nextId);
    formData.append('title', tourTitle);
    formData.append('description', tourDescription);
    formData.append('rate', tourRate);
    formData.append('days', dayCount);

    // NEW: route_image + route_description
    formData.append('route_image', routeImage);             // <— EXACT KEY
    formData.append('route_description', routeDescription); // <— EXACT KEY

    inputs.forEach((item, index) => {
      formData.append(`day_${index + 1}_photo`, item.photo);
      formData.append(`day_${index + 1}_description`, item.description);
    });

    try {
      const response = await axios.post(
        'https://genzserver.mylksystems.com/Tours/createTour',
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      // Refresh next ID after successful submission
      await getnextId();

      // Reset UI
      setDayCount(0);
      setInputs([]);
      setShowInputs(false);
      setTourDescription('');
      setTourRate('');
      setTourTitle('');

      // NEW: Reset route overview fields (including file input)
      setRouteImage(null);
      setRouteDescription('');
      setRouteImageKey((k) => k + 1);
    } catch (error) {
      console.error('Error submitting tour:', error);
      alert('Submission failed. Check console for details.');
    } finally {
      // Ensure spinner stops even on error
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        padding: '40px 20px',
        fontFamily: 'Segoe UI, sans-serif',
        backgroundColor: '#f8f9fa',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '800px',
          backgroundColor: 'white',
          padding: '40px',
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
        }}
      >
        <form onSubmit={handleFormSubmit}>
          <h2
            style={{
              fontSize: '28px',
              marginBottom: '20px',
              color: '#333',
              textAlign: 'center',
            }}
          >
            Create a New Tour
          </h2>

          {/* Tour Title */}
          <div style={{ marginBottom: '30px' }}>
            <label
              style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '16px' }}
            >
              Tour Title:
            </label>
            <textarea
              value={tourTitle}
              onChange={(e) => setTourTitle(e.target.value)}
              rows={3}
              placeholder="Enter a short Title for the tour"
              style={{
                width: '100%',
                padding: '12px',
                fontSize: '15px',
                borderRadius: '6px',
                border: '1px solid #ccc',
                resize: 'vertical',
                fontFamily: 'inherit',
              }}
              required
            ></textarea>
          </div>

          {/* Tour Description */}
          <div style={{ marginBottom: '30px' }}>
            <label
              style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '16px' }}
            >
              Tour Description:
            </label>
            <textarea
              value={tourDescription}
              onChange={(e) => setTourDescription(e.target.value)}
              rows={3}
              placeholder="Enter a short description for the tour"
              style={{
                width: '100%',
                padding: '12px',
                fontSize: '15px',
                borderRadius: '6px',
                border: '1px solid #ccc',
                resize: 'vertical',
                fontFamily: 'inherit',
              }}
              required
            ></textarea>
          </div>

          {/* Tour Rate */}
          <div style={{ marginBottom: '30px' }}>
            <label
              style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '16px' }}
            >
              Tour Rate:
            </label>
            <input
              value={tourRate}
              onChange={(e) => setTourRate(e.target.value)}
              placeholder="Enter Tour Rate in LKR"
              style={{
                width: '100%',
                padding: '12px',
                fontSize: '15px',
                borderRadius: '6px',
                border: '1px solid #ccc',
                fontFamily: 'inherit',
              }}
              type="number"
              min="0"
              required
            />
          </div>

          {/* === NEW: Route Overview === */}
          <div
            style={{
              marginBottom: '30px',
              padding: '20px',
              border: '1px solid #dee2e6',
              borderRadius: '10px',
              backgroundColor: '#fdfdfd',
            }}
          >
            <h3
              style={{
                marginBottom: '15px',
                fontSize: '22px',
                color: '#343a40',
              }}
            >
              Route Overview
            </h3>

            <div style={{ marginBottom: '15px' }}>
              <label
                style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}
              >
                Route Photo:
              </label>
              <input
                key={routeImageKey}             // forces a visual reset after submit
                type="file"
                accept="image/*"
                onChange={(e) => setRouteImage(e.target.files?.[0] || null)}
                required
                style={{
                  padding: '6px',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                  width: '100%',
                }}
              />
            </div>

            <div>
              <label
                style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}
              >
                Route Description:
              </label>
              <textarea
                value={routeDescription}
                onChange={(e) => setRouteDescription(e.target.value)}
                rows={4}
                style={{
                  width: '100%',
                  padding: '12px',
                  fontSize: '15px',
                  borderRadius: '6px',
                  border: '1px solid #ccc',
                  resize: 'vertical',
                  fontFamily: 'inherit',
                }}
                placeholder="Describe the overall route (e.g., start/end points, main attractions, highlights)"
                required
              ></textarea>
            </div>
          </div>
          {/* === /NEW === */}

          {/* Day Count */}
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '30px' }}>
            <input
              type="number"
              min="1"
              max="30"
              value={dayCount}
              onChange={handleDayChange}
              placeholder="Enter number of days"
              style={{
                padding: '10px 15px',
                fontSize: '16px',
                width: '180px',
                borderRadius: '6px',
                border: '1px solid #ccc',
                marginRight: '12px',
              }}
            />
            <button
              type="button"
              onClick={handleSubmitDays}
              style={{
                padding: '10px 20px',
                fontSize: '16px',
                backgroundColor: '#007BFF',
                color: '#fff',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
              }}
            >
              Submit Days
            </button>
          </div>

          {/* Day Inputs */}
          {showInputs &&
            inputs.map((input, index) => (
              <div
                key={index}
                style={{
                  marginBottom: '30px',
                  padding: '20px',
                  border: '1px solid #dee2e6',
                  borderRadius: '10px',
                  backgroundColor: '#fdfdfd',
                }}
              >
                <h3
                  style={{
                    marginBottom: '15px',
                    fontSize: '22px',
                    color: '#343a40',
                  }}
                >
                  Day {index + 1}
                </h3>

                <div style={{ marginBottom: '15px' }}>
                  <label
                    style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}
                  >
                    Photo:
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handlePhotoChange(index, e.target.files[0])}
                    required
                    style={{
                      padding: '6px',
                      borderRadius: '4px',
                      border: '1px solid #ccc',
                      width: '100%',
                    }}
                  />
                </div>

                <div>
                  <label
                    style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}
                  >
                    Description:
                  </label>
                  <textarea
                    value={input.description}
                    onChange={(e) => handleDescriptionChange(index, e.target.value)}
                    rows={4}
                    style={{
                      width: '100%',
                      padding: '12px',
                      fontSize: '15px',
                      borderRadius: '6px',
                      border: '1px solid #ccc',
                      resize: 'vertical',
                      fontFamily: 'inherit',
                    }}
                    placeholder={`Enter description for Day ${index + 1}`}
                    required
                  ></textarea>
                </div>
              </div>
            ))}

          {/* Submit Button */}
          {showInputs && (
            <div style={{ textAlign: 'center' }}>
              <button
                type="submit"
                disabled={loading}
                style={{
                  padding: '12px 30px',
                  fontSize: '18px',
                  backgroundColor: '#28a745',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s ease',
                  opacity: loading ? 0.85 : 1,
                }}
                onMouseOver={(e) => (e.target.style.backgroundColor = '#218838')}
                onMouseOut={(e) => (e.target.style.backgroundColor = '#28a745')}
              >
                {loading ? <ClipLoader color="#ffffff" size={20} /> : 'Submit Tour'}
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

export default Tours;
